import { useEffect } from "react";

export default function ThrowError() {
  useEffect(() => {
    throw new Error("ThrowError test component");
  }, []);
  return <></>;
}
